export class AuthV2ConfirmForgotPasswordRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "email",
            "baseName": "email",
            "type": "string",
            "format": ""
        },
        {
            "name": "confirmationCode",
            "baseName": "confirmationCode",
            "type": "string",
            "format": ""
        },
        {
            "name": "newPassword",
            "baseName": "newPassword",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AuthV2ConfirmForgotPasswordRequest.attributeTypeMap;
    }
    constructor() {
    }
}
